import { deviceType } from '@/utils/common'
import MobileHome from './mobile/dashboard/home.vue'
import PcHome from './pc/dashboard/index.vue'

const basePath = '/recruiting/personal/home'

export default {
  path: `${basePath}`,
  component: deviceType.isPc ? PcHome : MobileHome,
  meta: {
    isAllInclude: true,
    titleI18nKey: 'personal.home.title'
  }
}
